export const Config = {
    "currentFinancialDate": "2023-07-01",
    // "apiURL": "https://devgraphite.alphadirect.co.bw/api",
    "apiURL": "https://graphite.alphadirect.co.bw/api",
    // "apiNodeURL": "http://localhost:8000"
    "apiNodeURL": "https://reports.alphadirect.co.bw/backend"
    //"apiNodeURL": "http://localhost:8000"
}